import register from '@kpsys/angularjs-register';

import {LoginDataService} from './kp-login.data-service';
import {InternalLoginSystemDataService} from './login-systems/internal/internal.login-system.data-service';
import {LdapLoginSystemDataService} from './login-systems/ldap/ldap.login-system.data-service';

export default register('portaro.shared.login.kp-login')
    .service(LoginDataService.serviceName, LoginDataService)
    .service(InternalLoginSystemDataService.serviceName, InternalLoginSystemDataService)
    .service(LdapLoginSystemDataService.serviceName, LdapLoginSystemDataService)
    .name();
